export { FeatureBrandPage as BrandPage } from './lib/feature-brand-page'
export { getStaticProps } from './lib/get-static-props'

export { getStaticPathsGenerator } from './lib/get-static-path'
